import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../src/config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getChallangeDetailAction = createAsyncThunk(
    'get-challange-detail',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/users/api/challange/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getChallangeDetailSlice = createSlice({
    name: 'get-challange-detail',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getChallangeDetailAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getChallangeDetailAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getChallangeDetailAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getChallangeDetailReducer = getChallangeDetailSlice.reducer